__turbopack_context__.v({
  "personalDetailsTxt": "user-details-module-sass-module__Kv71Ea__personalDetailsTxt",
  "verificationBtn": "user-details-module-sass-module__Kv71Ea__verificationBtn",
  "warningIcon": "user-details-module-sass-module__Kv71Ea__warningIcon",
});
